import type { ReactNode } from 'react'

interface CallToActionBandProps {
  badge?: string
  title: string
  description: string
  actions?: ReactNode
}

export default function CallToActionBand({
  badge,
  title,
  description,
  actions,
}: CallToActionBandProps) {
  return (
    <section className="section-shell pt-0">
      <div className="mx-auto max-w-6xl">
        <div className="rounded-[2.25rem] border border-copper/20 bg-[linear-gradient(135deg,rgba(165,106,67,0.16),rgba(255,255,255,0.05))] p-8 shadow-soft backdrop-blur-md md:p-12">
          <div className="max-w-3xl">
            {badge ? <span className="section-badge">{badge}</span> : null}
            <h2 className="mt-5 text-4xl leading-tight md:text-5xl">{title}</h2>
            <p className="mt-5 max-w-2xl text-lg leading-8 text-weathered">{description}</p>
            {actions ? <div className="mt-8 flex flex-wrap gap-4">{actions}</div> : null}
          </div>
        </div>
      </div>
    </section>
  )
}
